// 活动计划列表页查询条件状态管理

const state = {
  defaultQueryCondition: {
    planStatus: null, // 状态
    budgetTypeCode: null,
    planCodeOrName: null,
    oneLevelCode: null,
    twoLevelCode: null,
    threeLevelCode: null
  },
  queryCondition: {
    planStatus: null, // 状态
    budgetTypeCode: null,
    planCodeOrName: null,
    oneLevelCode: null,
    twoLevelCode: null,
    threeLevelCode: null
  },
  pagination: {
    current: 1,
    size: 20,
    total: 0
  },
  showFilter: false,
  sourceList: {
    oneSourceList: [],
    twoSourceList: [],
    threeSourceList: []
  },
  defaultSourceList: {
    oneSourceList: [],
    twoSourceList: [],
    threeSourceList: []
  }
}

const mutations = {
  updateQueryCondition: (state, newCondition) => {
    state.queryCondition = newCondition
  },
  resetQueryCondition(state) {
    state.queryCondition = { ...state.defaultQueryCondition }
    state.pagination = {
      current: 1,
      size: 20,
      total: 0
    }
    state.sourceList.twoSourceList = state.defaultSourceList.twoSourceList
    state.sourceList.threeSourceList = state.defaultSourceList.threeSourceList
  },
  updatePagination(state, newPagination) {
    state.pagination = newPagination
  },
  updateShowFilter(state, newState) {
    state.showFilter = newState
  },
  updateSourceList(state, newState) {
    switch (newState.level) {
      case 1:
        state.sourceList.oneSourceList = newState.list
        break
      case 2:
        state.queryCondition.twoLevelCode = null
        state.queryCondition.threeLevelCode = null
        state.sourceList.twoSourceList = newState.list
        break
      case 3:
        state.queryCondition.threeLevelCode = null
        state.sourceList.threeSourceList = newState.list
        break
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
